/**
 * @generated SignedSource<<c3710f10c632af0b6baa616419987ea3>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type LinkedContent_images$data = ReadonlyArray<{
  readonly id: string;
  readonly sizes: ReadonlyArray<{
    readonly height: number;
    readonly width: number;
  }>;
  readonly " $fragmentSpreads": FragmentRefs<"Image_image" | "LinkedImageItem_image">;
  readonly " $fragmentType": "LinkedContent_images";
}>;
export type LinkedContent_images$key = ReadonlyArray<{
  readonly " $data"?: LinkedContent_images$data;
  readonly " $fragmentSpreads": FragmentRefs<"LinkedContent_images">;
}>;

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "LinkedContent_images",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ImageSize",
      "kind": "LinkedField",
      "name": "sizes",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "height",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "width",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "Image_image"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "LinkedImageItem_image"
    }
  ],
  "type": "Image",
  "abstractKey": null
};

(node as any).hash = "dc3bee87baff69388f4437fa1551f7b4";

export default node;
